/**
 * @description: 经验等级
*/
import React, { useContext, useEffect, useRef, useState } from "react";
import { LandC, LandA, LandB } from "../../components/land";
import { OrangeBtn, GreenBtn } from "../../components/button";
import classNames from "classnames";
import { expLevelInfo, receiveLevelPrize } from "@/api/guland";
import { hideLoading, showLoading } from "@/components/loading";
import { LandDetailContext } from "../context";
import { getLandIndex } from "../../utils";
import { Mask, Toast } from 'antd-mobile';
import "./experienceLevel.scss";
import RecycleCollectionsModal from "@/view/landGame/components/RecycleCollectionsModal";

const LevelMap = {
  a: 1,
  b: 2,
  c: 3
}

const ExpLandBox = ({
  mode,
  sticky = false,
  level = 0,
  shadow = false,
  activeStatus = 0,
}) => {
  const { landInfo } = useContext(LandDetailContext);

  return (
    <div
      className={classNames("land-game-exp__box", {
        sticky,
        "land-game-shadow": shadow,
        mode2: +mode == 2,
        mode3: +mode == 3,
      })}
    >
      <div> {level > 0 ? `${level} 级` : ""}</div>
      <div>
        {mode != 3 && (
          <>
            <div
              className={classNames(`land-game-box__${ activeStatus === 0 ? "active" : "default" }`, {mode2: +mode == 2, mode3: +mode == 3})}
            >
              <LandC scale={0.6} img={landInfo.currentLevel === 'c' ? landInfo.nftImage: ''}></LandC>
              <span>C级土地</span>
            </div>
            <div
              className={classNames(`land-game-box__${ activeStatus === 1 ? "active" : "default" }`, {mode2: +mode == 2, mode3: +mode == 3})}
            >
              <LandB scale={0.6} img={landInfo.currentLevel === 'b' ? landInfo.nftImage: ''}></LandB>
              <span>B级土地</span>
            </div>
          </>
        )}
        <div
          className={classNames(`land-game-box__${ activeStatus === 2 || (+mode === 3 && activeStatus === 0) ? "active" : "default" }`, {mode2: +mode == 2, mode3: +mode == 3})}
        >
          <LandA scale={0.6} img={landInfo.currentLevel === 'a' ? landInfo.nftImage: ''}></LandA>
          <span>A级土地</span>
        </div>
      </div>
    </div>
  );
};

const ExpBoxItem = ({prizeInfo, onReceive}) => {
  const { prize, prizeImage, prizeNum, isLock = 1, isReceived = 0 } = prizeInfo || {}
  // 兼容接口返回字符串类型
  const prizeType = Number(prize);
  const imageUrl = prizeImage || prizeInfo?.prizeImg || prizeInfo?.imageUrl || prizeInfo?.nftImage;

  /* prize=1 无奖励，不展示 */
  if (prizeType === 1) {
    return null;
  }

  const canReceive = Number(isLock) === 0 && Number(isReceived) === 0;
  const locked = Number(isLock) === 1;
  const received = Number(isReceived) === 1;
  // 2宝石始终展示数量；其他类型数量>1才展示
  const showNum = prizeType === 2 || Number(prizeNum) > 1;
  // 2宝石 / 3藏品 / 其余(能量、耗材等)走通用样式，避免新类型有图不渲染
  const boxClass =
    prizeType === 2
      ? "land-game-exp__box-el__score"
      : prizeType === 3
        ? "land-game-exp__box-el__star"
        : "land-game-exp__box-el__energy";

  return (
    <div
      className={classNames("land-game-exp__box-el", {
        "land-game-exp__box-el__canget": canReceive,
      })}
      onClick={() => {
        if (locked || received) return
        onReceive(prizeInfo)
      }}
    >
      {locked ? <div className="land-game-exp__box-el__lock"></div>: 
        !received ? <div className="land-game-exp__box-el__isReceived"></div>: 
      <div className="land-game-exp__box-el__received"></div>}
      <div className={classNames(boxClass, { __lock: locked })}>
        {imageUrl ? <img src={imageUrl} alt="" /> : null}
        {showNum ? (
          <span className={classNames({ __can__receive: canReceive })}>{prizeNum}</span>
        ) : null}
      </div>
    </div>
  );
};

const ExpBox = ({
  mode,
  sticky = false,
  level = 0,
  shadow = false,
  info,
  onReceive,
}) => {

  return (
    <>
      <div
        className={classNames("land-game-exp__box", {
          sticky,
          "land-game-shadow": shadow,
          mode2: +mode === 2,
          mode3: +mode === 3,
        })}
      >
        <div> {level > 0 ? `${level} 级` : ""}</div>

        <div>
          {info.map((x, i) => {
            // 黄金甲只有A级
            if(mode == 3 && x?.blockLevel !== 1) return null
            return (
              <div key={i}>
                {!!x && (
                  <ExpBoxItem prizeInfo={x} onReceive={onReceive}></ExpBoxItem>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

const ExperienceLevel = () => {
  const [list, setList] = useState([[], [], []]);
  const [levelInfo, setLevelInfo] = useState({})
  const [isCanReceiveAll, setIsCanReceiveAll] = useState(false)
  const [visible, setVisible] = useState(false)
  const [receiveList, setReceiveList] = useState([])
  const [isCenter, setIsCenter] = useState(false)
  const [openRecycleModalOpen, setOpenRecycleModalOpen] = useState(false)

  const { landInfo, setCurrentTab, refreshExp, pageInit, mode } = useContext(LandDetailContext);

  const activeStatus = +mode === 3 ? 0 : getLandIndex(landInfo.currentLevel);

  useEffect(() => {
    getExpLevelInfo();
  }, []);

  const getExpLevelInfo = async () => {
    try {
      showLoading();
      const res = await expLevelInfo({
        landId: landInfo.id,
        collectionId: landInfo.collectionId, 
        nftNo: landInfo.landId,
        spaceType: +mode === 3 ? 2 : +mode === 2 ? 1 : 0,//空间类型 0农业  1工业 2黄金甲
      });
      if (res.code !== '000000') throw res.msg
      const { 1: a, 2: b, 3: c } = res?.data?.landExpRewardRespMap || {};
      const canReceiveAll = res?.data?.landExpRewardRespMap?.[LevelMap[landInfo.currentLevel]]?.some(({isLock, isReceived}) => {
        return (isLock === 0 && isReceived === 0)
      })
      setIsCanReceiveAll(canReceiveAll)
      setList([c || [], b || [], a || []]);
      setLevelInfo(res?.data)
      hideLoading();
    } catch (error) {
      console.log(error)
      hideLoading();
      Toast.show(error)
    }
  };

  const receivePrize = async (expLevel) => {
    try {
      showLoading()
      const res = await receiveLevelPrize({
        nftNo: landInfo.landId,
        landId: landInfo.id,
        expLevelList: expLevel ? [expLevel]: null,
        spaceType: +mode === 3 ? 2 : +mode === 2 ? 1 : 0,//空间类型 0农业  1工业 2黄金甲
      })
      hideLoading()
      const { code, msg, data } = res
      if (code !== '000000') throw msg
      setReceiveList(data || [])
      setVisible(true)
    } catch (error) {
      hideLoading()
      Toast.show(error)
    }
  }

  const receiveAll = async () => {
    if (!isCanReceiveAll) return
    receivePrize('')
  }

  const receiveSingle = async (prizeInfo) => {
    receivePrize(prizeInfo.expLevel)
  }

  const len = Math.max(list[0]?.length, list[1]?.length, list[2]?.length) || 0;

  return (
    <div className="land-game-exp">
      <div className="land-game-exp__scrollbox">
        <div className={classNames("land-game-exp__scrollbox-bg",{mode2: mode == 2, mode3: mode == 3})}>
          <p></p>
          <div>
            {Array(3)
              .fill(0)
              .map((_, i) => (
                <p className={classNames({ __active: activeStatus === i })}
                  key={i}
                ></p>
              ))}
          </div>
        </div>
        <div className="land-game-exp__scroll">
          <div className="land-game-expscroll-box">
            <ExpLandBox sticky shadow mode={mode} activeStatus={activeStatus}></ExpLandBox>
            {len > 0 ? Array(len)
              .fill(0)
              .map((x, i) => (
                <ExpBox
                  mode={mode}
                  level={i + 1}
                  activeStatus={activeStatus}
                  key={i}
                  info={[list[0]?.[i], list[1]?.[i], list[2]?.[i]]}
                  onReceive={receiveSingle}
                ></ExpBox>
              )): null}
          </div>
        </div>
      </div>

      <div className={classNames("land-game-exp__bottom", {mode2: mode == 2, mode3: mode == 3})}>
        <span>
          本期剩余时间：{levelInfo?.remainTimeStr}
        </span>
        <div>
          <OrangeBtn onClick={() => setOpenRecycleModalOpen(true)}>回收</OrangeBtn>
          {/* 工业地和黄金甲土地不能升级 */}
          {mode !=2 && mode != 3 && <OrangeBtn
            onClick={() => {
              setCurrentTab("0");
            }}
          >
            升级土地
          </OrangeBtn>}
          <div className="land-width-52"></div>
          <GreenBtn disabled={!isCanReceiveAll} onClick={() => receiveAll()}>一键领取</GreenBtn>
        </div>
      </div>
      <Mask
        visible={visible}
        afterClose={() => {
          getExpLevelInfo()
          refreshExp()
          pageInit(undefined, false)
        }}
        afterShow={() => {
          const wList = document.getElementsByClassName("receive-prize-list")[0]?.offsetWidth
          const wItem = Array.from(document.getElementsByClassName("prize-list-item") || [])?.reduce((pre, cur) => {
            return pre + (cur.offsetWidth + parseInt(window.getComputedStyle(cur)['margin-right']))
          }, 0)
          const center = Number(wItem) < Number(wList)
          setIsCenter(center)
        }}
        style={{
          width: '100vw',
          height: '100vh',
          background: 'linear-gradient(180deg, #000000 0%, rgba(62, 62, 62, 0.9) 114%)',
        }}
      >
        <div className="receive-mask-content">
          <div className="receive-mask-bg">
            <div className={`receive-prize-list ${isCenter ? '': 'item-center'}`}>
              {
                receiveList.length > 0 && receiveList.map((item, index) => {
                  const prizeType = Number(item.prize);
                  const imageUrl = item.prizeImage || item.prizeImg || item.imageUrl || item.nftImage;
                  const showNum = prizeType === 2 || Number(item.prizeNum) > 1;
                  const boxClass =
                    prizeType === 2 ? "gemstone-box" : prizeType === 3 ? "ape-box" : "energy-box";
                  return <div className="prize-list-item" key={index}>
                    <div className="prize-box">
                      <div className={boxClass}>
                        {imageUrl ? <img src={imageUrl} alt="" /> : null}
                        {showNum ? <div>{item.prizeNum}</div> : null}
                      </div>
                    </div>
                    <p>{item.prizeName}</p>
                  </div>
                })
              }
            </div>
          </div>
          <div className="receive-mask-close" onClick={() => setVisible(false)}>点击空白区域继续</div>
        </div>
      </Mask>
      {/*回收藏品弹窗*/}
      <RecycleCollectionsModal
        visible={openRecycleModalOpen}
        onClose={() => setOpenRecycleModalOpen(false)}
        callback={refreshExp}
      />
    </div>
  );
};

export default ExperienceLevel;
